import styled from '@emotion/styled';
import { Theme } from '@seedlang/constants';
import { CaseMultipleChoiceCardWrapper } from '@seedlang/hoc';
import { DeckUI } from '@seedlang/state';
import CardText from 'components/card/card_text';
import EvaluateButtons from 'components/card/evaluate_buttons';
import MultipleChoiceButtons from 'components/card/multiple_choice_buttons';
import CardContent from 'components/layout/card_content';
import CardWrapper from 'components/layout/card_wrapper';
import Text from 'components/text';
import CardSection from 'components/vocab_card/card_section';
import MediaSection from 'components/vocab_card/media_section';
import { observer } from 'mobx-react';
import React from 'react';
import GrammarHint from 'components/grammar_hint';

const Feedback = styled.div`
  margin-top: 20px;
  text-align: center;
`;

const CaseLabel = styled.span`
  background: ${props => props.background};
  color: white;
  padding: 2px 6px;
  border-radius: 3px;
  font-weight: bold;
`;

@observer
class CaseMultipleChoiceCard extends React.Component {

  render() {
    return (
      <CardWrapper
        card={this.props.card}
        cardState={this.props.cardState}
        userCard={this.props.userCard}
        icons={this.props.icons}
      >
        <CardContent
          height={this.props.cardState.revealed ? DeckUI.layout.contentHeight : DeckUI.layout.contentHeightWithMultipleChoiceButtons(4)}
        >
          <MediaSection
            showMedia
            autoPlay={this.props.inView}
            card={this.props.card}
            cardState={this.props.cardState}
            height={this.props.mediaSectionHeight}
            borderTopRadius={10}
          />
          {
            Boolean(this.props.cardState.revealed) &&
            <CardSection
              padding={20}
              background='#f5f5f5'
              height={this.props.sectionHeight}
              borderBottomRadius={this.props.cardState.revealed ? 0 : 10}
            >

              <Feedback>
                <Text
                  bold
                  color={this.props.userCard.correct ? Theme.green : Theme.red}
                  fontSize={DeckUI.layout.deckHeight > 700 ? '18px' : '14px'}
                >
                  {this.props.currentMessage.prefix}
                  <CaseLabel background={this.props.correctAnswerBackgroundColor}>
                    {this.props.currentMessage.caseName}
                  </CaseLabel>
                </Text>
              </Feedback>
              {
                Boolean(this.props.grammarHint) &&
                <GrammarHint
                  description={this.props.grammarHint.description}
                  backgroundColor='transparent'
                  textColor='#000'
                  border='1px solid #000'
                />
              }
            </CardSection>
          }
          <CardSection
            padding='20px'
            background={this.props.cardState.revealed ? '#CCC' : '#FFF'}
            borderBottomRadius={10}
            height={this.props.sectionHeight}
          >
            <CardText
              card={this.props.card}
              showEdit
              cardState={this.props.cardState}
              sentence={this.props.card.sentence}
              showText
              showSentenceBreakdown
              showType={this.props.cardState.showType}
              sourceText={this.props.card.sentence?.sourceTextForUser(DeckUI.user)}
              highlightWordAssociationIds={this.props.cardState.revealed ? null : this.props.card.nounPhraseWordAssociationIds}
              highlightType='background'
              background={this.props.cardState.revealed ? '#CCC' : '#FFF'}
              showCase={this.props.cardState.revealed}
              prompt={this.props.cardState.revealed ? null : this.props.prompt}
              disableOnClick={!this.props.cardState.revealed}
              showUnderline={this.props.cardState.revealed}
              hideHighlight={false}
              showSpinner
              defaultBorderColor={this.props.cardState.revealed ? '#b0b0b0' : undefined}
            />
          </CardSection>
        </CardContent>
        {
          !this.props.cardState.revealed &&
          <MultipleChoiceButtons
            options={this.props.caseOptions}
            selected={this.props.selectedCase ? [this.props.selectedCase] : []}
            onClick={this.props.onSelectCase}
            disabled={!this.props.inView}
            field='label'
            languageId='DE'
            revealed={this.props.cardState.revealed}
            correct={this.props.userCard.correct}
            width={DeckUI.layout.innerDeckWidth}
            height={DeckUI.layout.totalMultipleChoiceButtonHeight(4)}
            buttonHeight={DeckUI.layout.multipleChoiceButtonHeight}
            fontSize='16px'
            isMobile={DeckUI.layout.isMobile}
          />
        }
        {
          this.props.cardState.revealed &&
          <EvaluateButtons
            card={this.props.card}
            cardState={this.props.cardState}
            userCard={this.props.userCard}
            disabled={!this.props.inView}
            onNextClick={this.props.onNextClick}
            onCheckAnswer={this.props.onCheckAnswer}
          />
        }
      </CardWrapper>
    );
  }
}

export default CaseMultipleChoiceCardWrapper(CaseMultipleChoiceCard);